import { Link, useSearchParams } from 'react-router-dom'

import TierBadge from '../components/TierBadge.jsx'
import { reasonText } from '../../functions/_lib/reasons.js'
import { useDocumentTitle } from '../useDocumentTitle.js'

// Where a sign-in that did not finish lands.
//
// 🔴 The reason is a CODE, looked up in a closed set. The query string is
// attacker-controllable — anybody can send anybody a link to this page — so the
// raw value is never rendered. An unknown code gets the generic sentence, and
// there is no branch where `searchParams.get('reason')` reaches the DOM.
//
// It shares one module with the Function that emits the codes
// (functions/_lib/reasons.js) so the two cannot disagree about what a code
// means. That is the same instinct as the section registry: one declaration,
// read by both ends.
//
// The refusal a member will actually see is `not-a-member`, and its wording is
// the one that matters. CLAUDE.md's Register section: plain language for
// refusals, no personality in an error, and it must not read as an accusation.
// It says what happened, who can fix it, and that this page cannot.
//
// This page is tier 1 — it is reachable signed out, by definition, and it says
// nothing about the server beyond that there is one.

export default function SignedOut() {
  const [params] = useSearchParams()
  const { heading, body } = reasonText(params.get('reason'))
  useDocumentTitle(heading)

  return (
    <article className="d2d-page">
      <header className="d2d-titleblock">
        <p className="d2d-eyebrow d2d-micro">
          <TierBadge tier={1} />
        </p>
        <h1 className="d2d-titleblock__headline">{heading}</h1>
        <p className="d2d-titleblock__lede" data-testid="signed-out-body">
          {body}
        </p>
        <hr className="d2d-rule" />
      </header>
      <p>
        <a href="/auth/login">Try signing in again</a>
      </p>
      <p>
        <Link to="/">Go to the start</Link>
      </p>
    </article>
  )
}
